export default [
  {
    path: '/configuraciones',
    name: 'settings',
    component: () => import('@/views/settings/AppSettings.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/configuraciones/inicio-de-sesion',
    name: 'loginSlidesSettings',
    component: () => import('@/views/settings/LoginSlidesSettings.vue'),
    meta: {
      requiresAuth: true,
      requiresAdmin: true,
    },
  },
  {
    path: '/configuraciones/terminos-y-privacidad',
    name: 'legalDocumentsSettings',
    component: () => import('@/views/settings/LegalDocumentsSettings.vue'),
    meta: {
      requiresAuth: true,
      requiresAdmin: true,
    },
  },
]
